<script setup>

import notification from "@/utils/plugins/NotificationService";
import IconVehicle from '@/components/icons/IconVehicle.vue';
import { computed, ref } from 'vue';



// Services
import VehicleServiceRequest from '@/api/services/vehicleRequest.service';

const comments = ref()

// eslint-disable-next-line no-undef
const emit = defineEmits(['close', 'finish']);

// eslint-disable-next-line no-undef
const props = defineProps({
    vehicleRequest: Object,
});

const request = computed(() => {
    return props.vehicleRequest;
})

const closeDialog = () => {
    emit('close');
}

const cancelRequest = () => {
    let params = {
        comment: comments.value,
    }
    VehicleServiceRequest.cancelVehicleRequest(request.value.id, params)
        .then((res) => {
            if (res && (res.status === 200 || res.status === 201))
                notification.addNotification({
                    type: 'success',
                    message: 'Solicitud cancelada',
                    duration: 4000
                })
            emit('finish')
            closeDialog();
        })

}
</script>

<template>
    <div>
        <div class="my-header">
            <div class="title-text ml-4">
                <IconVehicle class="iconVehicle" />
                Cancelar solicitud
            </div>
            <img class="close-icon pointer justify-content-end" src="@/assets/images/aspa_blue_small_entrada.png" alt=""
                @click="closeDialog()">
        </div>
        <div class="row d-flex">
            <div class="col-12 row d-flex mb-3">
                <div class="col-md-12 el-col-xs-24">
                    <label class="w-100" for="comments">Comentarios:</label>
                    <textarea v-model="comments" placeholder="Inserte comentarios de la cancelación de la solicitud"
                        id="comments" class="w-100 p-2" rows="4">
                        </textarea>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col d-flex justify-content-end gap-3">
                    <button class="btn btn_yellow px-4" @click="closeDialog()" style="width: 40%">
                        Cerrar
                    </button>

                    <button class="btn btn_red px-4" @click="cancelRequest()" style="width: 40%">
                        Cancelar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.my-header {
    margin-top: 2px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.iconVehicle {
    width: 40px;
    fill: $bg-blue;
}
</style>